import React, { useState, useEffect } from 'react';
import Menu from '../menu/Menu';
import Table from '../common/Table';
import RTSpinner from '../common/RTSpinner';
import RTButton from '../common/RTButton';
import { apiGet } from '../../api/apiClient';
import { formatDateToDDMMYYYY } from '../../utils/dateHelper';
import './ViewAllocatedBeds.css';

const ViewAllocationHistory = () => {
  const [loading, setLoading] = useState(true);
  const [allocations, setAllocations] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      // Fetch past allocation data (status not active)
      const allocationResponse = await apiGet('/allocation?status=AllocationEnded');
      setAllocations(allocationResponse.data);

    } catch (error) {
      console.error('Error fetching data:', error);
      setError('Failed to load allocation history data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handlePGClick = (pgId) => {
    window.open(`/paying-guest/view/${pgId}`, '_blank');
  };

  const handleBuildingClick = (buildingId) => {
    window.open(`/building/view/${buildingId}`, '_blank');
  };

  // Define table columns
  const columns = [
    {
      Header: 'Start Date',
      accessor: 'start_date',
      Cell: ({ value }) => formatDateToDDMMYYYY(value)
    },
    {
      Header: 'End Date',
      accessor: 'end_date',
      Cell: ({ value }) => formatDateToDDMMYYYY(value)
    },
    {
      Header: 'PG Name',
      accessor: 'pg_name',
      Cell: ({ value, row }) => (
        <RTButton
          type="link"
          onClick={() => handlePGClick(row.pg_id)}
          className="rt-link-button"
        >
          {value || 'N/A'}
        </RTButton>
      )
    },
    {
      Header: 'Building',
      accessor: 'building_name',
      Cell: ({ value, row }) => (
        <RTButton
          type="link"
          onClick={() => handleBuildingClick(row.building_id)}
          className="rt-link-button"
        >
          {value || 'N/A'}
        </RTButton>
      )
    },
    {
      Header: 'Room',
      accessor: 'room_type'
    },
    {
      Header: 'Rent Amount',
      accessor: 'rent_amount',
      Cell: ({ value }) => value ? `₹${value.toLocaleString()}` : 'N/A'
    }
  ];

  if (loading) {
    return <RTSpinner message="Loading allocation history data..." fullScreen={true} />;
  }

  return (
    <div className="rt-layout">
      <Menu />
      <div className="rt-main-content">
        <div className="rt-title-row">
          <h2 className="rt-title">Allocation History</h2>
          <div className="rt-actions">
            <RTButton variant="secondary" onClick={() => window.history.back()}>
              &#8592; Back
            </RTButton>
          </div>
        </div>

        {error && (
          <div className="rt-error-message">
            {error}
            <RTButton 
              type="primary" 
              onClick={fetchData}
              style={{ marginLeft: '10px' }}
            >
              Retry
            </RTButton>
          </div>
        )}

        {/* Allocation History Table */}
        <div className="rt-table-section">
          <Table
            title="Past Allocation Details"
            columns={columns}
            data={allocations}
            showSearch={true}
            exportable={true}
            showPagination={true}
            noDataText="No allocation history found."
            pageSize={20}
          />
        </div>
      </div>
    </div>
  );
};

export default ViewAllocationHistory;
